import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--chair@3x.png'

const path =
  'M50.26,0,23.65,15.37h0v8.55L0,37.58l0,0V43.8l.53.31V67.68l3.12,1.8,3.46-2V47.91L23.9,57.59V81L27,82.77l3.46-2V57.37l16-9.21V67.68l3.12,1.8,3.46-2V44.36l.59-.34V1.94ZM27,22.44h0V17.31l-1.68-1,1.68,1Z'

const Chair = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 53.62 82.77"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Chair.propTypes = IrregularInteraction.propTypes

export default Chair



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Chair.js